import { controller } from './controller';

export async function fetchBillingAccountSummary() {
  const res = await controller.get('/catalog/billing/account-summary');
  return res.data;
}

export async function fetchBillingBalance() {
  const res = await controller.get('/catalog/billing/balance');
  return res.data;
}

export async function fetchUserBillingBalance(userId) {
  const res = await controller.get(`/catalog/billing/users/${userId}/balance`);
  return res.data;
}

export async function billingTopUp(userId, amountUsd, note) {
  const res = await controller.post('/catalog/billing/top-up', {
    user_id: userId,
    amount_usd: amountUsd,
    note: note || undefined,
  });
  return res.data;
}

export async function quoteProjectPurchase(body) {
  const res = await controller.post('/catalog/purchase/quote/project', body);
  return res.data;
}

export async function quoteUidPurchase() {
  const res = await controller.post('/catalog/purchase/quote/uid');
  return res.data;
}

export async function quoteEntitlementsPurchase(slug, body) {
  const res = await controller.post(
    `/catalog/purchase/quote/entitlements/${encodeURIComponent(slug)}`,
    body,
  );
  return res.data;
}
